import React, { useEffect } from 'react';

const FinishedScreen = ({ score, gameData, resetGame }) => {
  // Log component lifecycle
  useEffect(() => {
    console.log('[FinishedScreen] Component mounted', {
      score,
      totalQuestions: gameData?.questionCount,
      percentage: gameData ? Math.round((score / gameData.questionCount) * 100) : 0,
      gameId: gameData?.gameId
    });
  }, [score, gameData]);

  const handlePlayAgain = () => {
    console.log('[FinishedScreen] Play again button clicked - returning to setup screen', {
      previousScore: score,
      previousGameId: gameData?.gameId
    });
    resetGame();
  };
  return (
    <div className="game-card">
      <h1><span role="img" aria-label="celebration">🎉</span> Game Complete!</h1>
      <div className="score-display">
        Final Score: {score} / {gameData.questionCount}
      </div>
      <p>
        {score === gameData.questionCount 
          ? "Perfect! You got them all right! 🏆" 
          : score >= gameData.questionCount * 0.8 
          ? "Great job! You did really well! 🌟" 
          : score >= gameData.questionCount * 0.6 
          ? "Good work! Keep practicing! 👍" 
          : "Keep trying! Practice makes perfect! 💪"
        }
      </p>
      <button className="start-button" onClick={handlePlayAgain}>
        New Game
      </button>
    </div>
  );
};

export default FinishedScreen;
